import React from 'react';

interface SelectCardBoxProps {
    items: { id: any; label: string; code?: any }[];
    selectedItems: any[] | null;
    onChange: (items: any) => void;
    isMulti?: boolean;
}

const SelectCardBox: React.FC<SelectCardBoxProps> = ({ items, selectedItems, onChange, isMulti=false }) => {

    const handleItemClick = (item: any) => {
        if (!isMulti) {
            console.log('item', item);
            onChange(item);
            return;
        } else {
            let updatedItems: any[] = [];
            if (selectedItems && selectedItems.find(
                (selectedItem) => selectedItem === item
            )) {
                updatedItems = selectedItems.filter((selectedItem) => selectedItem.code !== item.code);
            } else {
                updatedItems = selectedItems ? [...selectedItems, item] : [item];
            }
            onChange(updatedItems);
        }
            
    };

    return (
        <div className='flex flex-wrap'>
            {/* <div>{selectedItems ? selectedItems.map(item => (<span key={item.id}>{item.code}</span>)) : null}</div> */}
            {items.map((item) => (
                <div
                    key={item.id}
                    onClick={() => handleItemClick(item)}
                    style={{
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderRadius: '5px',
                        // borderColor: selectedItems && selectedItems.find((selectedItem) => selectedItem.code === item.code) ? '#f6475f' : '#ddd',
                        borderColor: 'transparent',
                        backgroundColor: selectedItems && selectedItems.find((selectedItem) => selectedItem.code === item.code) ? 'rgba(246, 71, 95, 0.9)' : '#fff',
                        color: selectedItems && selectedItems.find((selectedItem) => selectedItem.code === item.code) ? '#fff' : '#000',

                        padding: '10px',
                        margin: '5px',
                        cursor: 'pointer',
                    }}
                >
                    {item.label}
                </div>
            ))}
        </div>
    );
};

export default SelectCardBox;
